import { createBrowserRouter } from 'react-router-dom';
import { ProtectedRoute } from './components/layout/ProtectedRoute';
import { AppLayout } from './components/layout/AppLayout';
import { LandingPage } from './pages/LandingPage';
import { SignInPage } from './pages/SignInPage';
import { SignUpPage } from './pages/SignUpPage';
import { DashboardPage } from './pages/DashboardPage';
import { MatchesPage } from './pages/MatchesPage';
import { TeamPage } from './pages/TeamPage';
import { AssignmentsPage } from './pages/AssignmentsPage';
import { SettingsPage } from './pages/SettingsPage';
import { ProfilePage } from './pages/ProfilePage';
import { AdminPage } from './pages/AdminPage';
import { MyAssignmentsPage } from './pages/MyAssignmentsPage';
import { CompetenceMatrixPage } from './pages/CompetenceMatrixPage';
import { SalesPage } from './pages/SalesPage';
import { MarketInsightsPage } from './pages/MarketInsightsPage';

export const router = createBrowserRouter([
  { path: '/', element: <LandingPage /> },
  { path: '/sign-in/*', element: <SignInPage /> },
  { path: '/sign-up/*', element: <SignUpPage /> },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { path: 'dashboard', element: <DashboardPage /> },
          { path: 'profile', element: <ProfilePage /> },
          { path: 'matches', element: <MatchesPage /> },
          { path: 'team', element: <TeamPage /> },
          { path: 'matrix', element: <CompetenceMatrixPage /> },
          { path: 'assignments', element: <AssignmentsPage /> },
          { path: 'my-assignments', element: <MyAssignmentsPage /> },
          { path: 'settings', element: <SettingsPage /> },
          { path: 'admin', element: <AdminPage /> },
          { path: 'sales', element: <SalesPage /> },
          { path: 'market-insights', element: <MarketInsightsPage /> }
        ]
      }
    ]
  }
]);
